import { useCallback, useEffect, useState } from "react";
import { addressGetList } from "../../../services/address";
import { getContainersList } from "../../../services/container";

export const useCampaignFormData = () => {
  const [addressList, setAddressList] = useState([]);
  const [containerList, setContainerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFormData = async () => {
      setIsLoading(true);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const [addressResponse, containerResponse] = await Promise.all([
          addressGetList(
            {
              keywordFilter: "",
              listPostalCodeFilter: {},
              listCityFilter: {},
              sortByField: "name",
              orderSortByField: "1",
              listRoleFilter: {},
            },
            1,
            100,
          ),
          getContainersList({
            page: null,
            limit: null,
            fieldSort: "filling_level",
            orderSort: "-1",
            typeFillingFilter: "all",
          }),
        ]);

        const { getUserData } = await import("../../../services/users");
        const userData = await getUserData(user._id);
        const authorizedAddresses =
          userData.data.user?.authorizedAddresses || [];

        const filteredAddresses = addressResponse.data.data.filter((addr) =>
          authorizedAddresses.includes(addr._id.toString()),
        );
        setAddressList(filteredAddresses);
        setContainerList(containerResponse.data.data);
      } catch (error) {
        console.error("Error fetching campaign form data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFormData();
  }, []);

  const filterContainerByAddress = useCallback(
    (addressId) =>
      containerList.filter(
        (item) => item.addressId?.toString() === addressId?.toString(),
      ),
    [containerList],
  );

  return { addressList, containerList, filterContainerByAddress, isLoading };
};
